// hooks/useWishlist.js
import { useWishlistContext } from '../context/WishlistContext';

export const useWishlist = (product) => {
  const { isInWishlist, toggleWishlist } = useWishlistContext();
  return {
    isLiked: product ? isInWishlist(product._id) : false,
    toggleLike: () => product && toggleWishlist(product)
  };
};